<template>
  <create-dialog
    width="60%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div :class="`col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4`">
          <fg-input
            :label="`${$t('sowing.nursery')}: *`"
            class="shadow-sm required-name"
            ref="name"
            type="text"
            v-model="model.name"
            v-validate="modelValidations.name"
            name="sowing.nursery"
            :error="getError('sowing.nursery', true)"
            :placeholder="`${$t('common_words.name')}`"
          >
          </fg-input>
        </div>
        <div :class="`col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.company') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-business"
              size="large"
              v-model="model.business_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in businesses"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div :class="`col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.farm') }}: </label>
            <br />
            <el-select
              collapse-tags
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm"
              size="large"
              v-model="model.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-nursery',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['forceRerender'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinLoading,
    MixinValidations,
    MixinAlert,
    MixinPermissions,
  ],
  data() {
    return {
      businesses: [],
      farms: [],
      disabledField: false,
      model: {
        business_id: null,
        farm_id: null,
        name: null,
      },
      modelValidations: {
        name: { required: true },
      },
    };
  },
  methods: {
    validateForm() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business');
          } else {
            this.$emit('addEdit', this.model);
            return true;
          }
        }
      });
    },
  },
  mounted() {
    if (this.isCreate()) {
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('farms/farms/only'),
      ])
        .then(([responseBusinesses, responseFarms]) => {
          this.businesses = responseBusinesses.data.data;
          this.farms = responseFarms.data.data;
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...editForm,
        isEdit: true,
      };

      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
